module.exports = __webpack_public_path__ + "img/tickets-airline.cada1d1a.svg";